module.exports = __webpack_public_path__ + "img/ascend_gold46.669296cd.png";